import { FolderCloseIcon } from "../../../../../shared/icons/FolderCloseIcon";
import { FolderOpenIcon } from "../../../../../shared/icons/FolderOpenIcon";
import styles from "./styles.module.css";

interface Props {
  isFolder: boolean;
  isFolderOpen: boolean;
}

export const FolderIconComponent = ({ isFolder, isFolderOpen }: Props) => {
  if (!isFolder) return;

  if (isFolderOpen) {
    return <FolderOpenIcon className={styles["folder-icon"]} />;
  }

  return <FolderCloseIcon className={styles["folder-icon"]} />;
};
